import React from 'react'
import UserControlPage from './modules/UserControlPage'

const UserControl = () => {
  return <UserControlPage />
}

export default UserControl
